<nz-drawer
  [nzVisible]="showFile"
  [nzPlacement]="'right'"
  [nzClosable]="true"
  [nzTitle]="drawerHeader"
  (nzOnClose)="close()"
  [nzWidth]="'80vw'"
  [nzZIndex]="1200"
>
  <ng-container *nzDrawerContent>
    @if (viewInProgress) {
      <app-loading></app-loading>
    }

    @if (fileUrl) {
      @switch (fileViewer) {
        @case (null) {
          <app-loading></app-loading>
        }
        @case ('pdf') {
          <pdf-viewer
            [src]="fileUrl"
            [render-text]="true"
            [original-size]="false"
            [zoom]="zoom"
            style="width: 100%; height: 100%"
          ></pdf-viewer>
        }
        @case ('doc') {
          <ngx-doc-viewer
            [viewer]="'mammoth'"
            [url]="fileUrl"
            style="width: 100%; height: 100%"
          >
          </ngx-doc-viewer>
        }
        @case ('txt') {
          <pre>{{ textContent }}</pre>
        }
        @case ('html') {
          <div [innerHTML]="textContent"></div>
        }
        @case ('image') {
          <div class="img-preview-container">
            <img [src]="fileUrl" alt="image" />
          </div>
        }
        @case ('unknown') {
          <div class="no-preview flex flex-col">
            <div class="mb-16">
              {{ 'NOT_AVAILABLE_FOR_PREVIEW' | translate }}
            </div>
            <div>
              <ie-button
                [buttonType]="'outline'"
                [loading]="this.downloadInProgress"
                [onlyIcon]="true"
                (click)="downloadFile()"
                [disabled]="!fileUrl"
                icon="arrow-down"
              >
                {{ 'DOWNLOAD' | translate }}
              </ie-button>
            </div>
          </div>
        }
      }
    }
  </ng-container>
</nz-drawer>

<ng-template #drawerHeader>
  <div class="flex justify-between">
    <div>{{ fileName }}</div>
    @if (fileViewer === 'pdf') {
      <div class="flex">
        <ie-button
          [buttonType]="'outline'"
          [onlyIcon]="true"
          (click)="zoomIn()"
          [size]="'sm'"
          icon="search-zoom-in"
        >
        </ie-button>

        <ie-button
          [buttonType]="'outline'"
          [onlyIcon]="true"
          [disabled]="zoom === 0.5"
          (click)="zoomOut()"
          [size]="'sm'"
          icon="search-zoom-out"
          class="ml-8"
        >
        </ie-button>
      </div>
    }
  </div>
</ng-template>
